import React, { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { CheckCircle2, Loader2 } from "lucide-react";
import { useLang } from "@/context/LanguageContext";
import { useSubscription } from "@/context/SubscriptionContext";
import { useAuth } from "@/context/AuthContext";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const MAX_POLLS = 8;

const PaymentSuccess = () => {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const { t } = useLang();
  const { activate } = useSubscription();
  const { refresh } = useAuth();
  const sessionId = params.get("session_id");
  const [status, setStatus] = useState("pending");
  const [polls, setPolls] = useState(0);

  useEffect(() => {
    if (!sessionId) return;
    let cancelled = false;
    const poll = async () => {
      try {
        const { data } = await axios.get(`${API}/payments/status/${sessionId}`);
        if (cancelled) return;
        if (data.payment_status === "paid") {
          activate(sessionId);
          refresh();
          setStatus("paid");
          return;
        }
        if (polls + 1 >= MAX_POLLS) {
          setStatus("timeout");
          return;
        }
        setPolls((p) => p + 1);
        setTimeout(poll, 2000);
      } catch (e) {
        if (!cancelled) setStatus("error");
      }
    };
    poll();
    return () => { cancelled = true; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sessionId]);

  const isPaid = status === "paid";

  return (
    <div className="min-h-screen bg-[#050811] text-[#F8F5EE] flex flex-col items-center justify-center px-6" data-testid="payment-success-page">
      <div className="max-w-md w-full text-center border border-[#C1A661]/25 rounded-sm p-10 bg-[#080C17]">
        {isPaid ? (
          <>
            <CheckCircle2 size={52} strokeWidth={1.2} className="text-[#C1A661] mx-auto" />
            <h1 className="mt-5 font-serif text-3xl font-light text-[#E2CFA4]">{t.success.title}</h1>
            <p className="mt-3 text-sm text-[#A1A7B3] font-light">{t.success.body}</p>
          </>
        ) : (
          <>
            <Loader2 size={44} className="animate-spin text-[#C1A661] mx-auto" />
            <p className="mt-5 text-sm text-[#A1A7B3]">{t.success.pending}</p>
          </>
        )}
        <button
          data-testid="success-home-btn"
          onClick={() => navigate("/")}
          className="mt-8 w-full py-3 rounded-sm border border-[#C1A661]/40 hover:border-[#C1A661] text-[11px] tracking-[0.25em] uppercase text-[#E2CFA4] hover:text-[#F8F5EE] transition-colors"
        >
          {t.success.cta}
        </button>
      </div>
    </div>
  );
};

export default PaymentSuccess;
